<template>
  <span class="good-btn" :class="size" @click="favFunc">
    <!-- <i
      class="iconfont btn-msg"
      :class="{'text-red': hadFav}"
    ></i> -->
    <span class="btn-msg" :class="{'text-red': hadFav}">{{ hadFav? '已收藏': '收藏'}}</span>
    <span v-if="showCount" class="count">{{localGoodCount}}</span>
  </span>
</template>
<script>
import { Cms } from "@/api";
export default {
  name: "favBtn",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    sourceId: {
      required: true
    },
    size: {
      type: String,
      // normal 14px;
      // big 16px;
      default: "normal"
    },
    showCount: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      // article , comment
      default: "article"
    }
  },
  watch: {
    value: function(val) {
      this.hadFav = val;
    }
  },
  data() {
    return {
      localGoodCount: this.goodCount,
      hadFav: this.value,
      form: {
        ArticleId: this.sourceId,
        UserId: this.$mdUtils.getUserInfo("Id")
      }
    };
  },
  methods: {
    favFunc() {
      // let userId = this.$mdUtils.getUserInfo("Id")
      // if (!userId) {
      //   return this.$tips.error('请先登录')
      // }
      this.$api(Cms.ToggleFav, this.form).then(() => {
        this.hadFav = !this.hadFav;
        this.$emit("onSuccess", this.hadFav);
        this.$emit('input', this.hadFav)
      });
    }
  }
};
</script>
<style lang='scss' scoped>
.good-btn {
  font-size: 0 !important;
  .btn-msg {
    display: inline-block;
    font-size: $font-size-big;
  }
  &.normal {
    .btn-msg {
      font-size: $font-size-normal;
    }
    .count {
      margin-left: 5px;
      font-size: $font-size-normal;
    }
  }
  &.middle {
    .btn-msg {
      font-size: 20px;
    }
    .count {
      margin-left: 5px;
      font-size: 20px;
    }
  }
  &.big {
    .btn-msg {
      font-size: $font-size-normal;
    }
    .count {
      margin-left: 12px;
      font-size: $font-size-big;
    }
  }
}
</style>